module.exports = __webpack_public_path__ + "static/media/commit-details.ec6dd7f0.jpg";